module.exports = __webpack_public_path__ + "img/option_a.8ca5976a.png";